/* eslint-disable @typescript-eslint/no-unsafe-call */
export class ApiHelper {
    public createUrl(baseUrl: string, parameters?: any): string {
        let url = baseUrl;
        if (parameters) {
            let i = 0;
            for (const property in parameters) {
                // eslint-disable-next-line no-prototype-builtins
                if (!parameters.hasOwnProperty(property)) {
                    continue;
                }
                const value = parameters[property];
                if (this._isValidValue(value)) {
                    url += (i === 0 ? '?' : '&');
                    let stringToAppend = property + '=' + encodeURIComponent(value.toString());

                    if (Array.isArray(value)) {
                        stringToAppend = '';
                        let j = 0;
                        for (const item of value) {
                            if (item !== null && item !== undefined) {
                                stringToAppend += (j === 0 ? '' : '&') + property + '=' + encodeURIComponent(item.toString());
                                j++;
                            }
                        }
                    }
                    url += stringToAppend;
                    i++;
                }
            }
        }
        return url;
    }

    private _isValidValue(val: any): boolean {
        if (val === null || val === undefined) {
            return false;
        }
        if (Array.isArray(val) && val.length === 0) {
            return false;
        }
        return true;
    }
}
